<template>
    <div class="clearfix twoStep"  v-loading="loading">
        <div>
            <el-form :model="form" :rules='rules' class="form" label-width="220px" ref="form">
                <el-card class="complaint-card">
                    <div class="clearfix" slot="header">
                        投诉编号：<span>{{form.complaintCode}}</span>
                    </div>
                    <div class="left-complain-con">
                        <el-row>
                            <el-col :offset="4" :span="16">
                                <el-form-item label="受理状态：" v-if="hasBtnPermission('online_complaints_btn_handle') && form.receiveStatus==1">
                                    <el-button @click="dealFn(1)" type="primary">受理</el-button>
                                    <el-button @click="dealFn(2)">不予受理</el-button>
                                </el-form-item>
                                <div :class="[form.receiveStatus!=1?'bgCssBox':'']" style="padding-right: 24px">
                                    <el-form-item label="受理状态：" v-if="form.receiveStatus!=1">
                                        {{form.receiveStatus==3?'受理':'不予受理'}}
                                    </el-form-item>
                                    <template v-if="form.receiveStatus==3">
                                        <el-form-item label="受理部门：">
                                            {{form.receiverOrgName}}
                                        </el-form-item>
                                        <el-form-item label="受理人员：">
                                            {{form.receiverName}}
                                        </el-form-item>
                                        <el-form-item label="受理时间：">
                                            {{form.receiveTime}}
                                        </el-form-item>
                                    </template>
                                    <template v-else-if="form.receiveStatus==2">
                                        <el-form-item label="不予受理原因：" prop="reasonCode">
                                            <el-select :disabled="isView" clearable filterable placeholder="请选择" v-model="form.reasonCode">
                                                <el-option
                                                :key="item.value"
                                                :label="item.name"
                                                :title="item.name"
                                                :value="item.value"
                                                v-for="item in departmentOptions">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="不予受理回复：" prop="reasonReply">
                                            <el-input :disabled="isView" :rows="5" maxlength="255" show-word-limit type="textarea" v-model="form.reasonReply"></el-input>
                                        </el-form-item>
                                        <div :key="index" v-for="(item,index) in form.attachments" >
                                            <el-form-item :label="item.fileTypeName?(item.fileTypeName+'：'):'附件：'" :prop="'attachments' + item.fileType" size="small"  v-if="!isView">
                                                <affix-msg
                                                        :docItem.sync="item"
                                                        :docName.sync="item.name"
                                                        @multipleUploadSuccess="(data)=>multipleUploadSuccess(data,index)"
                                                        @uploadSuccess="uploadSuccess"/>
                                            </el-form-item>
                                            <affix-doc
                                                :item.sync="item"
                                                :name="item.fileTypeName"
                                                class="affixDown"
                                                labelWidth="220px"
                                                v-else
                                            />
                                        </div>
                                    </template>
                                    <div class="imgCss">
                                        <img :src="require('@/assets/img/complaint/ysl.png')" v-if="form.receiveStatus==3"/>
                                        <img :src="require('@/assets/img/complaint/bysl.png')" v-else-if="form.receiveStatus==2"/>
                                    </div>
                                </div>
                        </el-col>
                    </el-row>
                    </div>
                    <div class="imgCss" v-if="form.receiveStatus==1">
                        <img :src="require('@/assets/img/complaint/dsl.png')"/>
                    </div>
                </el-card>
            </el-form>
                
        </div>
    </div>
</template>

<script>
import affixMsg from '@/components/affixMsg';
import affixDoc from '@/components/affixDoc';
import {dealAttachment} from '@/utils';
import {mapState} from 'vuex'
    export default {
    props:["mainContentViewHeight","tradeId"],
    data(){
        return{
            loading:false,
            height:document.documentElement.clientHeight - 341,
            form: {
                id:'',
                receiverOrgName:'',
                receiverName:'',
                receiveTime:'',
                receiveStatus:'',
                reasonReply:'',
                reasonCode:'',
                complaintCode:'',
                attachments:[]
                
            },
            rules:{
                reasonCode:[{required:true, message:'请选择不予受理原因',trigger:['blur','change']}],
                reasonReply:[{required:true, message:'请输入不予受理回复',trigger:'blur'}],
            },
            departmentOptions:[],
            code:'',
            status:'',
            isView:false,
        }
    },
    components:{
        affixMsg,
        affixDoc
    },
    filters:{
    },

    created(){
        this.$store.dispatch('dataDictionary/getReceiveSuggesstionAtt');
    },
    computed: {
        ...mapState({
            receiveSuggesstionAtt: (state) => {return  state.dataDictionary.receiveSuggesstionAtt},
        }),
    },
    watch: {
        receiveSuggesstionAtt: {
            immediate: true,
            deep: true, // 深度监听
            handler(val, newVal) {
                this.$nextTick(()=>{
                    // 初始化附件数据
                    let attachments = JSON.parse(JSON.stringify(this.receiveSuggesstionAtt));
                    this.form.attachments = attachments;
                    this.addFormRules(this.form.attachments);
                })

            }
        }
    },

    mounted() {
        this.loading=true;
        if(this.$route.query.id){
            this.id=this.$route.query.id;
            this.code=this.$route.query.code;
            this.$set(this.form,'receiveStatus',1)
            this.$set(this.form,'complaintCode',this.code)
            this.getData();
            this.getDic()

        }
    },
    methods:{
        dealFn(type){//是否受理
            if(type==1){
                this.form.receiveStatus=3;
                this.submitData();
            }else{
                this.form.receiveStatus=2;
                this.deal();
            }
        },
        getData(){//获取受理数据
            this.$httpReq({
                url: `/complaint/getReceiveData?complaintId=`+this.id,
                method: 'get',
                }).then((res) => {
                    if(res.data.code != '1'){
                        return
                    }
                    this.$set(this.form,'id',res.data.data.id)
                    this.$set(this.form,'receiveStatus',res.data.data.receiveStatus)
                    this.form = {...res.data.data};
                    this.status= res.data.data.receiveStatus;

                // 附件数据处理start
                let attachments= this.receiveSuggesstionAtt.length > 0?JSON.parse(JSON.stringify(this.receiveSuggesstionAtt)):JSON.parse(JSON.stringify(this.form.attachments));
                this.form.attachments = dealAttachment(attachments,res.data.data.attachments);
                // 附件数据处理end

                    if(this.form.receiveStatus==2){
                        this.isView=true;
                    }else{
                        this.isView=false;
                    }

                    this.deal();
                    
            }).finally(()=>{this.loading=false;})
        },
        submitData(){//提交数据
            this.$httpReq({
                url: `/complaint/receive`,
                method: 'post',
                data:this.form
                }).then(({data}) => {
                    if(data.code==1){
                        this.form=data.data;
                        this.$message.success('保存成功')
                        this.getData()
                    }else{
                        this.$message.error(data.msg)
                    } 
            })
        },
        getDic(){
            this.$httpReq.get('/sys/dictData/getList?type=jg_not_receive_reason').then(res=>{
                if(res.data.code=='1'){
                    this.departmentOptions=res.data.data;
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },
        // 添加表单验证规则
        addFormRules(attachments){
            const _this = this;
            attachments.length > 0 && attachments.forEach((item,index)=>{
                if(item.required){
                    let string = 'attachments' + item.fileType;
                    _this.rules[string] = [
                        {
                            required: true,
                            validator:  function(rule,value,callback){
                                if ( _this.form.attachments[index].filePath) {
                                    callback();
                                } else {
                                    callback(new Error('请上传'+_this.form.attachments[index].fileTypeName));
                                }
                            }
                        }]
                }
            })
        },
        uploadSuccess(fileType){
            this.$refs['form'].clearValidate(['attachments'+fileType]);
        },
        multipleUploadSuccess(data,index){
            // this.form.attachments.splice(index+1,1,data)
        },
        deal(){//是否有下一步  2两个都没有,3有下一步按钮，1有提交按钮
            if(this.status==2){
                this.$emit('isTwo', 2);
            }else if(this.status==3){
                this.$emit('isTwo', 3);
            }else{
                if(this.form.receiveStatus==2){
                    this.$emit('isTwo', 1);
                }else{
                    this.$emit('isTwo', 2);
                }
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .twoStep{
        margin-top: 20px;
        position: relative;
        .imgCss{
            position: absolute;
            top: 32px;
            right: 48px;
        }
        .el-button{
            padding: 8px 20px;
        }
        .bgCssBox{
            position: relative;
            background: #ffffff;
            border: 1px solid #D8D8D8;
            padding: 5px 0;
        }
    }
</style>